import { render, staticRenderFns } from "./BranchFilter.vue?vue&type=template&id=4f6460ed&scoped=true&"
import script from "./BranchFilter.vue?vue&type=script&lang=ts&"
export * from "./BranchFilter.vue?vue&type=script&lang=ts&"
import style0 from "./BranchFilter.vue?vue&type=style&index=0&id=4f6460ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6460ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBadge,VBtn,VCard,VCol,VMenu,VProgressCircular,VRow,VSheet,VTextField,VTreeview})
